import React from 'react';
import { Select, MenuItem, ListSubheader } from '@mui/material';
import { headingBlue } from '../../assets/colors';

const GroupedDropDown = (props) => {
    return (
        <Select
            fullWidth
            variant="outlined"
            value={props.value}
            displayEmpty
            renderValue={() => {
                if (props.value === props.placeHolder) return props.placeHolder;
                // Find child in the list of parent/children
                let foundName = props.value;
                for (const parent of props.list) {
                    const match = parent.children.find(child => 
                        (typeof child === 'object' ? child._id === props.value : child === props.value)
                    );
                    if (match) {
                        foundName = typeof match === 'object' ? match.name : match;
                        break;
                    }
                }
                return foundName;
            }}
            style={{ 
                textAlign: 'left', 
                color: (props.value === props.placeHolder) ? '#B0B0B0' : 'black', 
                fontSize: '0.9rem',
                height: props.height ? props.height : "2rem",
                padding: "0.2rem",
                paddingLeft: "0rem",
                boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3"
            }}
            onChange={(e) => props.setFunc(e.target.value)}
            MenuProps={{
                PaperProps: {
                    style: { maxHeight: '250px' }
                }
            }}
        >
            <MenuItem value={props.placeHolder} disabled>{props.placeHolder}</MenuItem>
            {props.list.flatMap((parent, index) => [
                <ListSubheader key={`header-${index}`} style={{ color: headingBlue, fontWeight: 'bold', lineHeight: '2em' }}>
                    {parent.parentName}
                </ListSubheader>,
                ...parent.children.map(child => {
                    const isObj = typeof child === 'object';
                    const val = isObj ? child._id : child;
                    const label = isObj ? child.name : child;
                    return (
                        <MenuItem key={`${index}-${val}`} value={val} style={{ paddingLeft: '2rem', minHeight: '2em' }}>
                            {label}
                        </MenuItem>
                    );
                })
            ])}
        </Select>
    );
};

export default GroupedDropDown;
